// Defer atting src attirbute to video elements untill page has loaded.
export default function initBannerVideos() {
    const bannerVideos = document.querySelectorAll('video[data-src]');
    const getUrlExtension = (url) => {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    };
    if (bannerVideos) {
        document.addEventListener('DOMContentLoaded', () => {
            bannerVideos.forEach((videoEl) => {
                const videoElement = videoEl;
                videoElement.innerHTML = `<source src="${
                    videoEl.dataset.src
                }" type="video/${getUrlExtension(videoEl.dataset.src)}">`;
            });
        });
    }
}

initBannerVideos();
